module.exports = __webpack_public_path__ + "static/media/SUV.d84f9ec2.svg";